import { ThemeUICSSObject } from '@apia/theme';
import decAdm from './decAdm';
import groups from './groups';
import orgRole from './orgRole';
import orgUnit from './orgUnit';
import users from './users';
import profiles from './profiles';
import resetPassword from './resetPassword/resetPassword';
import hierarchicalStructure from './hierarchicalStructure';
import tasklist from './tasklist';
import styles from './styles';
import decAdmGlobal from './decAdmGlobal';
import functionalities from './functionalities';
import aiConnectors from './aiConnectors';
import customComponent from './customComponent';
/* IMPORT HERE */
const administration: ThemeUICSSObject = {
  aiConnectors,
  customComponent,
  groups,
  users,
  decAdm,
  decAdmGlobal,
  orgRole,
  orgUnit,
  profiles,
  functionalities,
  resetPassword,
  hierarchicalStructure,
  tasklist,
  styles,
  /* PREPEND HERE */
};

export default administration;
